export const levelColors = {
  B1: "from-purple-500 to-purple-600",
  B2: "from-orange-500 to-orange-600",
  C1: "from-pink-500 to-pink-600",
};

export const BGlevelColors = {
  B1: "bg-[#9333ea]",
  B2: "bg-[#EA580C]",
  C1: "bg-[#db2777]",
};